import { createContext, useState } from 'react';

export const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [siteData, setSiteData] = useState({});
  const [showLocModal, setShowLocModal] = useState(false);
  const [showCookieModal, setShowCookieModal] = useState(false);

  // useEffect(() => {
  //     (async () => {
  //         try {
  //             const response = await axios.get("/admin/fundamentals/get-global-data");
  //             let data = JSON.parse(response.data.site_data);
  //             setSiteData(data);
  //         } catch (error) {
  //             setSiteData({})
  //         }
  //     })();
  // }, []);

  return (
    <ConfigContext.Provider
      value={{ siteData, showLocModal, setShowLocModal, showCookieModal, setShowCookieModal }}
    >
      {children}
    </ConfigContext.Provider>
  );
};
